import { makeAutoObservable, runInAction } from 'mobx'
import { CreateOrder, Order, OrderStatus } from '../models/Payments'
import agent from '../api/agent'

export default class PaymentStore {
  paymentRegistry = new Map<string, Order>()

  selectedPayments: Order | undefined = undefined

  editOrder: OrderStatus | undefined = undefined

  loadingPayments = true

  constructor() {
    makeAutoObservable(this)
  }

  get payments() {
    return Array.from(this.paymentRegistry.values())
  }

  loadPayments = async () => {
    this.loadingPayments = true
    const { status, data: payments } = await agent.Payments.list()
    if (status === 200) {
      runInAction(() => {
        payments.forEach((pay) => {
          this.paymentRegistry.set(pay.id, pay)
        })
        this.loadingPayments = false
      })
    }
  }

  orderById = async (id: string) => {
    try {
      const { status, data: payments } = await agent.Payments.details(id)
      if (status === 200) {
        runInAction(() => {
          this.selectedPayments = payments
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  editOrderStatus = async (id: string, status: number) => {
    try {
      await agent.Payments.editOrderStatus(id, { status })
    } catch (error) {
      console.log(error)
    }
  }

  createOrder = async (order: CreateOrder) => {
    const { status, data: payments } = await agent.Payments.createOrder(order)
    if (status === 200) {
      if (payments.link) {
        window.open(payments, '_blank') // This will open the link in a new window/tab
      }
    }
  }
}
